import styled from '@emotion/styled'

import { PostNotFoundMessage } from './PostNotFoundMessage'
import { PostRepostText } from './PostRepostText'
import { PostActionBar } from './PostActionBar'
import { PostHeading } from './PostHeading'
import { PostMedia } from './PostMedia'
import { PostBody } from './PostBody'
import { PostActionBarFullScreen } from './PostActionBarFullScreen'

const RightPanel = styled.div`
  overflow: hidden;
  width: 100%;
`

const PostRightPanel = ({
  post, user, media, setPanelWidth, panelWidth,
  isReplyTop, isReplyBottom, isRepost, reposter, isFullScreenActionBar,
  clickHandlers, stats
}) => {
  return (
    <RightPanel
      ref={(node) => node && setPanelWidth(node?.clientWidth)}>
      <PostRepostText
        isRepost={isRepost}
        reposter={reposter}
      />
      <PostNotFoundMessage post={post} />
      {post?.uuid &&
        <>
          <PostHeading
            user={user}
            post={post}
            isReplyBottom={isReplyBottom}
            handleThreeDotsClick={clickHandlers?.handleThreeDotsClick}
          />
          <PostBody
            handleBodyClick={clickHandlers?.handleBodyClick}
            body={post?.body}
          />
          <PostMedia
            panelWidth={panelWidth}
            media={media}
          />
          {/* TODO: We'll need to check if its the reply bottom or the base post display, and prevent rendering for them only */}
          {!isFullScreenActionBar && (
            <PostActionBar
              clickHandlers={clickHandlers}
              stats={stats}
              isReplyTop={isReplyTop}
              media={media}
            />
          )}
        </>
      }
    </RightPanel>
  )
}

export { PostRightPanel }
